import { useMemo } from 'react';
import type { Middleware } from '@floating-ui/dom';
import { useTheme } from '@trinity/chat-components/components/Theme';

export const useZIndexMiddleware = (overrideZIndex?: number) => {
  const theme = useTheme();
  const zIndex = overrideZIndex ?? (theme.zIndex.baseModal + 1);

  return useMemo(() => {
    const middleware: Middleware = {
      name: 'zIndexer',
      options: {
        zIndex,
      },
      fn: (data) => {
        data.elements.floating.style.zIndex = `${zIndex}`;
        return data;
      },
    };
    return middleware;
  }, [zIndex]);
};

export const useSameWidthMiddleware = () => {
  return useMemo(() => {
    const middleware: Middleware = {
      name: 'sameWidth',
      options: {
        sameWidth: true,
      },
      fn: (data) => {
        const refWidth = (data.elements.reference as HTMLDivElement).offsetWidth;
        data.elements.floating.style.width = `${refWidth}px`;
        return data;
      },
    };
    return middleware;
  }, []);
};